import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { SortIcon } from '@/icons/sort-icon';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/recommendation-management')({
  loader: ({ context }) => {
    context.groupLabel = 'recommendationManagement.sidebar.title';
    context.childRoutes = [
      {
        id: 'recommendationManagement.sidebar.menu.mainPage',
        label: 'Main Page',
        path: '/recommendation-management/main-page',
        icon: SortIcon,
      },
      {
        id: 'recommendationManagement.sidebar.menu.editorPick',
        label: 'Editors Pick',
        path: '/recommendation-management/editors-pick',
        icon: SortIcon,
      },
    ];

    return {
      crumb: (
        <CrumbTitle
          title="recommendationManagement.page.crumb.recommendationManagement"
          id="recommendationManagement.page.crumb.recommendationManagement"
          icon={SortIcon}
        />
      ),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
